import { ApolloError } from '@apollo/client'
import { isEmpty } from 'lodash'

import { GetDebitCardTransactions_getDebitCardTransactionsV2_transactions as DebitCardTransaction } from 'types/gql-types/GetDebitCardTransactions'
import { GenericErrorPage } from 'components/Placeholders/GenericErrorPage/GenericErrorPage'
import { NoSearchResults } from 'components/Placeholders/NoAccountTransactions'
import { PlaceholderSize } from 'components/Placeholders/Placeholders.types'

import { DebitCardTransactionListSkeleton } from './DebitCardTransactionListSkeleton/DebitCardTransactionListSkeleton'
import { DebitCardTransactionsList } from './DebitCardTransactionsList/DebitCardTransactionsList'
import { ListGroupItemDebitCardTransactions } from './DebitCardTransactionsList/ListGroupItemDebitCardTransactions/ListGroupItemDebitCardTransactions'
import { NoDebitCardTransactions } from './NoDebitCardTransactions/NoDebitCardTransactions'

interface ErrorDisplayProps {
  retry: () => void
}

interface DebitCardTransactionsListProps {
  groupedDebitCardTransactions: DebitCardTransaction[][]
  hasNoInitialResults: boolean
  onLoadMore: () => void
  loading: boolean
  hasMore: boolean
  error: ApolloError | undefined
  refetch: () => void
  handleSelectedTransactionUpdate: (
    update: Partial<DebitCardTransaction>
  ) => void
  listHeight?: string
  ErrorDisplay?: (errorProps: ErrorDisplayProps) => JSX.Element
  Row?: typeof ListGroupItemDebitCardTransactions
  unfilteredEmptyState?: JSX.Element
  filteredEmptyState?: JSX.Element
}

export const DebitCardTransactions = ({
  groupedDebitCardTransactions,
  hasNoInitialResults,
  onLoadMore,
  loading,
  hasMore,
  error,
  refetch,
  handleSelectedTransactionUpdate,
  listHeight,
  ErrorDisplay = ({ retry }) => (
    <GenericErrorPage variant={PlaceholderSize.Large} retry={retry} />
  ),
  Row = ListGroupItemDebitCardTransactions,
  unfilteredEmptyState = <NoDebitCardTransactions />,
  filteredEmptyState = <NoSearchResults />,
}: DebitCardTransactionsListProps) => {
  if (loading) {
    return <DebitCardTransactionListSkeleton />
  }

  if (error) {
    return <ErrorDisplay retry={() => refetch()} />
  }

  if (hasNoInitialResults) {
    return unfilteredEmptyState
  }

  if (isEmpty(groupedDebitCardTransactions)) {
    return filteredEmptyState
  }

  return (
    <DebitCardTransactionsList
      groupedTransactions={groupedDebitCardTransactions}
      fetchMore={onLoadMore}
      hasMore={hasMore}
      handleSelectedTransactionUpdate={handleSelectedTransactionUpdate}
      listHeight={listHeight}
      Row={Row}
    />
  )
}
